import { restClient } from '@/api/client'
import { endpoints } from '@/api/endpoints'

const q = (p: Record<string, unknown>) => new URLSearchParams(
  Object.entries(p).filter(([, v]) => v !== undefined && v !== null && v !== '').reduce((a, [k, v]) => ({ ...a, [k]: String(v) }), {})
).toString()

export interface AssistantPaymentPerson {
  id: number
  name?: string | null
  name_ar?: string | null
  email?: string | null
  phone?: string | null
  photo_url?: string | null
  [k: string]: unknown
}

export interface AssistantPaymentBooking {
  id: number
  booking_method?: string | null
  booking_status?: string | null
  payment_method?: string | null
  payment_status?: string | null
  category_id?: number | null
  city_id?: number | null
  package_id?: number | null
  no_of_sessions?: number | null
  total_amount?: number | null
  driver?: AssistantPaymentPerson | null
  driver_id?: number | null
  user?: AssistantPaymentPerson | null
  user_id?: number | null
  sessions?: unknown[] | null
  created_at?: string | null
  updated_at?: string | null
  [k: string]: unknown
}

export interface AssistantPayment {
  id: number
  assistant_id: number
  assistant?: AssistantPaymentPerson | null
  assistant_name?: string | null
  booking?: AssistantPaymentBooking | null
  amount?: number | null
  booking_id: number
  paid_on_behalf_student_id?: number | null
  payment_status?: string | null
  is_approved?: boolean
  document_path?: string | null
  txn_id?: string | null
  remarks?: string | null
  remark_ar?: string | null
  remark_ur?: string | null
  created_at?: string | null
  updated_at?: string | null
  updated_by?: number | null
}

export interface AssistantPaymentListResponse {
  status: string
  message: string
  total: number
  count_per_page: number
  data: AssistantPayment[]
}

export const assistantBookingService = {
  // is_approved: 1 = approved list, 2 = pending list
  paymentList: (p: { page?: number; limit?: number; is_approved?: number } = {}) => {
    const params: Record<string, unknown> = {
      page: p.page ?? 1,
      limit: p.limit ?? 15,
      is_approved: p.is_approved ?? 1,
    }
    return restClient
      .get<AssistantPaymentListResponse>(`${endpoints.assistant.booking.paymentList}?${q(params)}`)
      .then(r => r.data)
  },
  // mapping_id = the assistant-payment record id; is_approved: 1 = approve, 0 = decline
  approveOrDecline: (data: { mapping_id: number; is_approved: 0 | 1 }) =>
    restClient.post(endpoints.assistant.booking.paymentApproveOrDecline, data).then(r => r.data),
}
